/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f4ab9b1a0920181f3d53deb6a9ab36c36f5a4a5b";
